export default "__VITE_ASSET__y41MSVIu__"